import { post } from './requests'

export const viewTip = key => params =>
  post(['user-tips', 'view-tip'], {
    key,
    params,
    transformPayload: true,
  })
